import { Component, OnInit, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';

import {default as gridColumnsJSON} from 'app/Shared/Constant/Grid Column Names/Market-Abuse.json';
import { CommonGridComponent } from '../common-grid/common-grid.component';


@Component({
    selector: 'app-market-abuse',
    imports: [CommonGridComponent],
    templateUrl: './market-abuse.component.html',
    styleUrls: ['./market-abuse.component.scss']
})
export class MarketAbuseComponent implements OnInit {
  gridColumns = gridColumnsJSON;
  constructor() { }

  ngOnInit() {
  }

}
